import { defineStore } from "pinia";

export const useLayoutStore = defineStore("layout", {
  state: () => ({
    layoutType: "vertical",
    leftSidebarType: "dark",
    layoutWidth: "fluid",
    topbar: "dark",
    mode: localStorage.getItem('waos_rm.theme') || "light"
  }),
  actions: {
    changeMode(mode) {
      this.mode = mode
      window.localStorage.setItem('waos_rm.theme', mode);
    }
  }
});
